import React from 'react';
import { isVideo } from 'helpers';
import CarouselVideo from 'components/CarouselVideo';

const ProfileVideoFilter = ({ files }) => (
  <>
    {files.length > 0 && files.map((img, index) => {
      if(isVideo(img.orig_src)){
        return(
          <CarouselVideo
            src={img.orig_src} 
            index={index}
            ext={img.thumb_src} 
            activeIndex={index}
            videoStyles={{ width: "100%", height: '118px' }}
            showFullScreen
          />
        )
      }       
    })}
  </>
);

export default ProfileVideoFilter;
